module.exports = __webpack_public_path__ + "static/media/partner03.0d091731.svg";